import Consumptions from "../../components/Consumptions/Consumptions";
import { Chart, registerables } from "chart.js";

const ConsumptionsPage = () => {
  Chart.register(...registerables);
  Chart.defaults.font.family = "Roboto";
  Chart.defaults.font.size = 14;

  return <Consumptions />;
};

export default ConsumptionsPage;
